import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  endpoint = `${this.env.URL_API}/usuario`;
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  currentUser = {};

  constructor(private http: HttpClient, public router: Router, private env: EnvService) { }

  login(user) {
    return this.http.post<any>(`${this.env.URL_API}/usuario/login`, user);
  }
  loginAD(nm) {
    return this.http.post<any>(`${this.env.URL_API}/usuario/loginAD`, nm);
  }

  getToken() {
    return sessionStorage.getItem('access_token');
  }

  get isLoggedIn(): boolean {
    const authToken = sessionStorage.getItem('access_token');
    return authToken !== null ? true : false;
  }

  // User profile
  getUserProfile(id): Observable<any> {
    if (id) {
      const api = `${this.endpoint}/${id}`;
      return this.http.get(api, { headers: this.headers }).pipe(
        map((res: Response) => {
          return res || {};
        }),
        catchError(this.handleError)
      );
    }
  }

  // Error
  handleError(error: HttpErrorResponse) {
    let msg = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      msg = error.error.message;
    } else {
      // server-side error
      msg = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(msg);
  }
}
